import { Link, useLocation, useNavigate } from 'react-router-dom';
import { transferNoticeUrl } from '../../utils/transferNotice';
import Layout from '../../components/Public/Layout';
import LongArrow from '../../icon/mainPage_arrow.svg';
import headset from '../../icon/headset.svg';
import incruit from '../../icon/incruit.svg';
import { ToastContainer } from 'react-toastify';
import { useContext, useEffect, useState } from 'react';
import ChannelTalkContext from '../../context/ChannelTalkContext';
import { successToast } from '../../utils/toast';
import { onToggleModal } from '../../utils/utils';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import SUCCESS from '../../icon/success.svg';
import CustomModal from '../../components/Modal/CustomModal';
import PrivacyRevisionNotice from '../../components/Public/PrivacyRevisionNotice';
import ResumeTransitionNotice from '../../components/Public/ResumeTransitionNotice';
import { PRIVACY_POLICY, TERMS } from '../../utils/StaticVariable/policyContent';
import useUpdateTitle from '../../hooks/updateTitle';

const MainResume = () => {
  useUpdateTitle();
  const location = useLocation();
  const navigate = useNavigate();
  const { openChannelChat } = useContext(ChannelTalkContext);

  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState('');
  const [modalType, setModalType] = useState('');

  useEffect(() => {
    if (location.state === 'active') {
      setIsOpen(true);
      setModalType('confirm');
      setState('active');
      navigate(location.pathname, { replace: true });
    } else if (location.state === 'inquiry') {
      setIsOpen(true);
      setModalType('confirm');
      setState('inquiry');
      navigate(location.pathname, { replace: true });
    } else if (location.state === 'delete') {
      successToast(<div>이력서 삭제가 완료되었습니다.</div>);
      navigate(location.pathname, { replace: true });
    } else if (location.state === 'recruitapply') {
      setIsOpen(true);
      setModalType('confirm');
      setState('recruitapply');
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return (
    <Layout>
      <PrivacyRevisionNotice className="mx-auto" />
      <ResumeTransitionNotice className="mx-auto mt-3" />
      <div className="px-auto pt-[40px] pb-[72px] text-center">
        <p className="text-[32px] font-bold ">재택 근무를 희망하는 장애인 구직신청</p>
      </div>
      <div className="flex items-center gap-5">
        <a
          href={transferNoticeUrl("resume-write")}
          className="group bg-[#F4F4F4] ml-auto rounded-[32px] w-[552px] px-[48px] py-[62px] cursor-pointer transition hover:bg-[#16C1B1]"
          aria-label="이력서 등록하기 / 시각장애인인 경우 하단 간편문의를 이용해보세요"
        >
          <p className="text-[34px] mb-[40px] font-bold text-gray-900 group-hover:text-white">이력서 등록</p>
          <p className="h-[149px] text-[20px] text-gray-500 group-hover:text-white">
            새로운 맞춤형 이력서를 등록 하시는 경우
          </p>
          <img
            src={LongArrow}
            className="ml-auto mt-[12px]"
          />
        </a>
        <a
          href={transferNoticeUrl("resume-read")}
          className="group mr-auto bg-[#F4F4F4] rounded-[32px] w-[552px] px-[48px] py-[62px] hover:bg-[#16C1B1]"
          aria-label="이력서 조회하기"
        >
          <p className="text-[34px] mb-[40px] font-bold text-gray-900 group-hover:text-white">이력서 조회</p>
          <p className="h-[149px] text-[20px] text-gray-500 group-hover:text-white">이미 이력서를 등록 하신 경우</p>
          <img
            src={LongArrow}
            className="ml-[314px] mt-[12px]"
          />
        </a>
      </div>
      <div className="mt-4 flex items-center">
        <a
          href={transferNoticeUrl("resume-recruitlist")}
          className="group bg-[#C2CFFF] ml-auto rounded-[32px] w-[552px] h-[130px] px-[48px] py-[40px] cursor-pointer transition hover:bg-[#9bb0ff] flex items-center justify-between"
        >
          <p className="text-[34px] font-bold text-gray-900 group-hover:text-black">채용공고</p>
          <img src={incruit} />
        </a>
        <button
          type="button"
          onClick={() => openChannelChat()}
          className="group mr-auto ml-[20px] bg-[#FFD26E] rounded-[32px] w-[552px] h-[130px] px-[48px] py-[40px] hover:bg-[#FFCC00]"
          aria-label="간편문의 하기"
        >
          <div className="flex items-center justify-between w-full">
            <p className="text-[34px] font-bold text-gray-900 group-hover:text-black">간편문의</p>
            <img src={headset} />
          </div>
        </button>
      </div>
      <div className="flex mt-[156px] mb-[24px] items-center">
        <div className="w-[1124px] mx-auto text-right">
          <Link
            className="cursor-pointer"
            to="/resume/privacy-policy"
          >
            개인정보 처리방침
          </Link>
          <span> | </span>
          <button
            className="cursor-pointer"
            onClick={() => {
              onToggleModal(setIsOpen);
              setModalType('terms');
            }}
          >
            이용 약관
          </button>
        </div>
      </div>
      {/* 이용 약관 모달 */}
      {isOpen && modalType === 'terms' && (
        <CustomModal
          width="md:w-[1000px]"
          padding="py-[20px] md:p-[56px]"
          title="[이용 약관]"
          setIsOpen={setIsOpen}
          isOpen={isOpen}
        >
          <div className="mx-[40px] md:mx-[80px]">{TERMS}</div>
        </CustomModal>
      )}
      {/* 이력서 작성 완료 modal */}
      {isOpen && modalType === 'confirm' && (
        <ConfirmModal
          width="md:w-[550px]"
          padding="py-[20px] md:pb-[32px] md:pt-[0px]"
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          type="complete"
          title={
            <div className="flex gap-2">
              <img
                src={SUCCESS}
                width="24px"
                height="24px"
                aria-label=""
              />
              <p tabIndex="0">
                {state === 'active'
                  ? '이력서 등록이 완료됐습니다.'
                  : state === 'inquiry'
                    ? '문의 접수가 완료됐습니다.'
                    : '입사지원이 완료됐습니다.'}
              </p>
            </div>
          }
          content={
            <p
              className="text-left mx-6 mt-4"
              tabIndex="0"
            >
              {state === 'active' ? (
                <>
                  저희 브이드림에 이력서를 제출해 주셔서 감사합니다.
                  <br /> 수시 채용의 경우 매칭되는 기업이 있을 시 등록된 연락처로 개별 연락드리며,
                  <br /> 이력서 수정이 필요한 경우
                  <Link
                    className="text-[#3333FF] font-[450]"
                    to="/read"
                    aria-label="이력서 조회 페이지로 이동"
                  >
                    &nbsp;[이력서 조회]&nbsp;
                  </Link>
                  페이지를 이용하시기 바랍니다.
                </>
              ) : state === 'inquiry' ? (
                <>접수하신 내용은 확인 후, 입력하신 연락처를 통해 연락 드리도록 하겠습니다.</>
              ) : (
                ''
              )}
            </p>
          }
          onClose={() => {
            onToggleModal(setIsOpen);
            setState('');
            setModalType('');
          }}
        ></ConfirmModal>
      )}
      <ToastContainer />
    </Layout>
  );
};

export default MainResume;
